import Vue from 'vue'
import Firebase from './firebase.js'
import store from './store.js'


function createTask(queueName, taskdesc) {
  var originalTaskDesc = taskdesc
  return new Vue({
    name: 'Task_'+queueName,
    store,
    data: {
      id: undefined,
      desc: undefined,
      timeout: undefined,
    },
    watch: {
      'desc.state': function(newVal) {
        var ev = 'state-'+newVal
        //console.log('emit state change', ev)
        this.$emit(ev, this)
        if (this.timeout && (newVal=='success' || newVal=='error')) {
          clearTimeout(this.timeout)
          this.timeout = undefined
        }
      }
    },
    methods: {
      cancel() {
        if (this.desc && (this.desc.state == 'pending' || this.desc.state == 'busy')) {
          console.log('canceling task', queueName)
          this.$firebaseRefs.desc.update({state: 'canceled'})
        }
      },
      timedOut() {
        this.$emit('state-timeout', 1234)
      },
      remove() {
        //ERR: don't have db permission to rm
        //console.log('removing task', this.$firebaseRefs.desc)
        //this.$firebaseRefs.desc.remove()
      },
    },
    created: function() {
      this.$nextTick(() => {
        var qprefix = this.$store.state.dev.developmentWorkers ? 'dev-' : ''
        console.log("createTask ", qprefix+queueName)
        var job = Firebase.database.ref("/workitems/"+qprefix+queueName).push();
        var taskdesc = { params: originalTaskDesc,
                         uid: this.$store.state.uid,
                         state: "pending",
                         progress: 0,
                         createStamp: { ".sv" : "timestamp" } }
        job.set(taskdesc)
        this.id = job.key
        this.$bindAsObject('desc', job)
        //this.timeout = setTimeout( this.timedOut, 1*1000)
      })
    },
  });
}

const MAX_BATCH_SIZE = 2
const MAX_CONCURRENT_TASKS = 8
const DEFAULT_TASKER_SCALEOUT = { maxBatchSize: MAX_BATCH_SIZE,
                                  maxConcurrentTasks: MAX_CONCURRENT_TASKS }

function createPostTasker(queuename, params, scaleout=DEFAULT_TASKER_SCALEOUT) {
  return new Vue({
    name: 'PostTasker_'+queuename,
    data: {
      requested: [], active: [], done: [],
      tasks: [],
      errorCount: 0,
      halted: false,
    },
    methods: {
      cancel: function() {
        this.requested.length = 0
        this.tasks.forEach( task => {
          task.$off()
          task.cancel()
        })
        this.tasks = []
      },
      updateOutstanding: function(outstandingPosts) {
        //console.log("PostTasker::updateOutstanding", queuename, outstandingPosts)
        this.requested = outstandingPosts.filter(p => this.active.indexOf(p) < 0
                                                 && this.done.indexOf(p) < 0)        
        this.update()
      },
      prioritise: function(priorityPosts) {
        console.log("PostTasker::priorityPosts", queuename, priorityPosts)
        var prioritised = this.requested.filter(p=>priorityPosts.indexOf(p)<0)
        Array.prototype.unshift.apply(prioritised, priorityPosts)
        this.updateOutstanding(prioritised)
      },
      force: function(priorityPosts) {
        console.log("PostTasker::force", queuename, priorityPosts)
        this.done = this.done.filter((p,i) => priorityPosts.indexOf(p) < 0)
        this.prioritise(priorityPosts)
      },
      update: function() {
        while (!this.halted && this.requested.length && this.tasks.length < MAX_CONCURRENT_TASKS) {
          var batch = Math.min(scaleout.maxBatchSize, this.requested.length)
          var pids = this.requested.splice(0, batch)
          Array.prototype.push.apply(this.active, pids)
          //console.log('PostTasker::update', queuename, this.active)
          var desc = Object.assign({}, params, { pids: pids })          
          var task = createTask(queuename, desc);
          console.log('PostTasker::created', queuename, pids, 'from', this.requested)
          task.$on('state-success', this.onTaskSuccess)
          task.$on('state-error', this.onTaskError)
          task.$on('state-timeout', this.onTaskError)
          this.tasks.push(task)
        }
      },
      onTaskSuccess: function(task) {
        var pids = task.desc.params.pids
        console.log('TaskSuccess', queuename, pids, this.active, 'by', task.desc._worker, this.tasks.length)
        Array.prototype.push.apply(this.done, pids)
        this.resetTask(task)
        this.$emit('success', pids)
      },
      onTaskError: function(task) {
        var pids = task.desc.params.pids
        console.log('TaskError', queuename, pids, task.desc.error)
        Array.prototype.unshift.apply(this.requested, pids)
        if (++this.errorCount > 100) {
          this.halted = true
        }
        const msg = task.desc.error ? task.desc.error.message||'no msg' : 'no err'
        this.resetTask(task)
        this.$emit('error', pids, msg, task.desc.error)
      },
      resetTask: function(task) {
        var pids = task.desc.params.pids
        console.log('TASK reset:', task.desc, pids, 'of', this.tasks.length)

        task.remove()
        task.$off()
        this.tasks = this.tasks.filter(t => t !== task)
        this.active = this.active.filter( p => pids.indexOf(p) < 0 )
        this.update();
      },
      isIdle: function() {
        return !this.task
      }
    },
  });
}


export default {
  createTask,
  createPostTasker,
  MAX_IN_PROGRESS_PIDS: MAX_BATCH_SIZE * MAX_CONCURRENT_TASKS,
}



// WEBPACK FOOTER //
// ./src/tasker.js